const BRAND = 'Brand';
const BROKER = 'Broker';

export {
    BRAND,
    BROKER,
};
